import http from '../../../services/api'
import type { APIPaginatedResponse, APIResponse, Filters, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'

const apiPath = import.meta.env.VITE_API_PATH

export type InventoryLocationApi = {
  id: number
  name: string
  code: string | null
  type: number
  is_active: boolean
  business_id?: number
  branch_uuid?: string | null
  branch_name?: string | null
  created_at?: string
  updated_at?: string
}

export type CreateInventoryLocationInput = {
  name: string
  code?: string | null
  type: number
  is_active?: boolean
}

export type UpdateInventoryLocationInput = CreateInventoryLocationInput & {
  id: number
}

async function getLocations(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getRequestParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<InventoryLocationApi>>(apiPath + 'inventory/locations' + paramString)
}

async function createLocation(input: CreateInventoryLocationInput) {
  const payload = {
    name: input.name,
    code: input.code?.trim() ? input.code.trim() : null,
    type: input.type,
    is_active: input.is_active ?? true,
  }
  return await http.post<APIResponse<InventoryLocationApi>>(apiPath + 'inventory/locations', payload)
}

async function updateLocation(input: UpdateInventoryLocationInput) {
  const payload = {
    name: input.name,
    code: input.code?.trim() ? input.code.trim() : null,
    type: input.type,
  }
  return await http.put<APIResponse<InventoryLocationApi>>(`${apiPath}inventory/locations/${input.id}`, payload)
}

async function deactivateLocation(id: number) {
  return await http.patch<APIResponse<InventoryLocationApi>>(`${apiPath}inventory/locations/${id}/deactivate`, {})
}

const locationsService = {
  getLocations,
  createLocation,
  updateLocation,
  deactivateLocation,
}

export default locationsService
